import template from './uimessages.html';
import './uimessages.scss';
/**
 * Handles all the user interactions with the notifications.
 */
class UIMessagesController {
  /**
   * Called when the user hits `Accept` on the confirmation prompt. It calls the method that
   * informs the implementation of confirmation prompt results.
   */
  acceptConfirm() {
    this._confirmAction(true);
  }
  /**
   * Called when the user hits `Cancel` on the confirmation prompt. It calls the method that
   * informs the implementation of confirmation prompt results.
   */
  cancelConfirm() {
    this._confirmAction(false);
  }
  /**
   * Called when the user closes the alert window. It informs the implementation, but because
   * only one alert may be open at the same time, it doesn't send any information.
   */
  closeAlert() {
    this.onAlertAction();
  }
  /**
   * Called when the user closes a notification. It informs the implementation by sending
   * the notification information.
   * @param {Object} notification The notification information.
   */
  closeNotification(notification) {
    this.onNotificationCloseRequest({ notification });
  }
  /**
   * Informs the implementation what the user decided regarding a confirmation prompt.
   * @param {boolean} value Whether the user accepted or cancelled the confirmation prompt.
   * @access protected
   * @ignore
   */
  _confirmAction(value) {
    this.onConfirmAction({ value });
  }
}
/**
 * Shows notifications, an alert window and a confirmation prompt.
 * @ngesdoc component
 * @ngname uimessages
 * @ngcontroller {@link UIMessagesController}
 * @ngmodule common
 * @ngbinding {Array}    notifications              The list of notifications to show.
 * @ngbinding {Function} onNotificationCloseRequest The callback the component calls when a user
 *                                                  closes a notification. It will receive a
 *                                                  `notification` parameter.
 * @ngbinding {boolean}  showAlert                  Whether or not to show an alert.
 * @ngbinding {Object}   alertInfo                  The information of the alert that will be shown.
 * @ngbinding {Function} onAlertAction              The callback the component calls when a user
 *                                                  _"accepts"_ or closes the alert.
 * @ngbinding {boolean}  showConfirm                Whether or not to show a confirmation prompt.
 * @ngbinding {Object}   confirmInfo                The information of the confirmation prompt that
 *                                                  will be shown.
 * @ngbinding {Function} onConfirmAction            The callback the component calls when the user
 *                                                  _"accepts"_ or _"cancels"_ the prompt. It will
 *                                                  receive a `value` parameter.
 *
 */
export default {
  controller: UIMessagesController,
  template,
  bindings: {
    notifications: '<',
    onNotificationCloseRequest: '&',
    showAlert: '<',
    alertInfo: '<',
    onAlertAction: '&',
    showConfirm: '<',
    confirmInfo: '<',
    onConfirmAction: '&',
  },
};
